import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const InstagrmAlert = styled.div`
  position: fixed;
  top: 0;
  z-index: 5;
  padding: 10px;
  width: 100%;
  background-color: ${colors.orange800};
  text-align: center;
  left: 50%;
  transform: translate(-50%);

  @media (min-width: 600px) {
    max-width: 450px;
  }
`;

export const FixedBottom = styled.section`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 20px 12px 10px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.46) 0%,
    rgba(255, 255, 255, 0.84) 19.79%,
    rgba(255, 255, 255, 0.92) 61.46%,
    #fff 100%
  );

  backdrop-filter: blur(1px);

  @media (min-width: 600px) {
    max-width: 450px;
  }
`;

export const TermsContainer = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;

  a {
    text-decoration: underline;
    color: ${colors.gray600};
  }
`;
